import React, { useEffect, useState } from "react";
import { Zap, Timer } from "lucide-react";

const TopBar = () => {
  const [time, setTime] = useState({ h: 1, m: 42, s: 17 });

  useEffect(() => {
    const iv = setInterval(() => {
      setTime((t) => {
        let { h, m, s } = t;
        if (s > 0) s -= 1;
        else if (m > 0) { m -= 1; s = 59; }
        else if (h > 0) { h -= 1; m = 59; s = 59; }
        return { h, m, s };
      });
    }, 1000);
    return () => clearInterval(iv);
  }, []);

  const pad = (n) => String(n).padStart(2, "0");

  return (
    <div className="w-full bg-gradient-to-r from-pink-600 via-rose-500 to-pink-600 text-white">
      <div className="max-w-6xl mx-auto px-3 py-2 flex flex-row items-center justify-center gap-3 md:gap-6 text-[12px] md:text-[15px] font-medium">
        <div className="flex items-center gap-1.5 md:gap-2">
          <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 fill-yellow-300 text-yellow-300" strokeWidth={2} />
          <span className="hidden sm:inline">Desconto EXCLUSIVO só hoje nesta página</span>
          <span className="sm:hidden">Oferta encerra em</span>
        </div>
        <div className="hidden md:block h-4 w-px bg-white/30" />
        <div className="flex items-center gap-1.5 md:gap-2 bg-white/15 backdrop-blur px-2.5 md:px-3 py-0.5 md:py-1 rounded-full">
          <Timer className="w-3.5 h-3.5 md:w-4 md:h-4" />
          <span className="tabular-nums font-semibold tracking-wide">
            {pad(time.h)}h : {pad(time.m)}m : {pad(time.s)}s
          </span>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
